import fp from "fastify-plugin";
import type {
  FastifyInstance,
  FastifyPluginAsync,
  FastifyPluginOptions,
} from "fastify";
import { createClient, type RedisClientType } from "redis";
import { env } from "../config/env.js";

declare module "fastify" {
  interface FastifyInstance {
    redis: RedisClientType;
  }
}

const redisPlugin: FastifyPluginAsync = async (
  fastify: FastifyInstance,
  options: FastifyPluginOptions,
) => {
  const redis = createClient({
    url: env.REDIS_URL,
  });

  await redis.connect();
  fastify.decorate("redis", redis);
  fastify.addHook("onClose", async () => {
    await redis.quit();
  });
};

export default fp(redisPlugin, {
  name: "redis",
});
